module.exports = __webpack_public_path__ + "img/money-now.712cc970.svg";